import { Translation } from 'react-i18next'
import { Campaign, CampaignState } from '../../../types'
import Tag, { TagVariant } from '../../../ui/Tag'

interface CampaignTagParams {
    campaign: Pick<Campaign, 'state' | 'progress' | 'send_at' | 'deleted_at'>
}

export const CampaignTag = ({ campaign: { state, progress, send_at, deleted_at } }: CampaignTagParams) => {
    const variant: Record<CampaignState, TagVariant> = {
        draft: 'plain',
        aborted: 'error',
        aborting: 'error',
        loading: 'info',
        scheduled: 'info',
        running: 'info',
        finished: 'success',
        archived: 'error',
    }

    const complete = progress?.complete ?? 0
    const total = progress?.total ?? 0
    const percent = total > 0 ? complete / total : 0
    const percentStr = percent.toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 0 })

    let label: string = state
    if (state === 'aborting' && send_at) label = 'rescheduling'
    if (deleted_at) label = 'archived'

    let key: CampaignState = state
    if (deleted_at) key = 'archived'

    return <Tag variant={variant[key]}>
        <Translation>{(t) => t(label)}</Translation>
        {progress && ` (${percentStr})`}
    </Tag>
}
